import { render, staticRenderFns } from "./VotingRightsApproval.vue?vue&type=template&id=7ab0eea6"
import script from "./VotingRightsApproval.vue?vue&type=script&lang=js"
export * from "./VotingRightsApproval.vue?vue&type=script&lang=js"
import style0 from "./VotingRightsApproval.vue?vue&type=style&index=0&id=7ab0eea6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports